import { Controller } from "@hotwired/stimulus";

// Simplified news filter: each article item has featured + grid markup;
// first match shows featured, subsequent matches show grid up to page*pageSize.
export default class extends Controller {
  static targets = [
    "item",
    "featured",
    "grid",
    "empty",
    "count",
    "more",
    "search",
    "filterBtn",
  ];
  static values = {
    pageSize: { type: Number, default: 6 },
    page: { type: Number, default: 1 },
    filter: { type: String, default: "全部" },
  };

  connect() {
    this.apply();
  }

  setFilter(event) {
    this.filterValue = event.currentTarget.dataset.tag;
    this.pageValue = 1;
    this.filterBtnTargets.forEach((btn) => {
      const on = btn.dataset.tag === this.filterValue;
      btn.classList.toggle("bg-accent", on);
      btn.classList.toggle("border-accent", on);
      btn.classList.toggle("text-white", on);
      btn.classList.toggle("border-border", !on);
      btn.classList.toggle("text-muted-foreground", !on);
    });
    this.apply();
  }

  search() {
    this.pageValue = 1;
    this.apply();
  }

  loadMore() {
    this.pageValue += 1;
    this.apply();
  }

  matchedItems() {
    const q = this.hasSearchTarget ? this.searchTarget.value.trim() : "";
    return this.itemTargets.filter((el) => {
      const tagOk =
        this.filterValue === "全部" || el.dataset.tag === this.filterValue;
      const hay = `${el.dataset.title || ""}${el.dataset.summary || ""}`;
      const searchOk = !q || hay.includes(q);
      return tagOk && searchOk;
    });
  }

  apply() {
    const matched = this.matchedItems();
    this.featuredTarget.innerHTML = "";
    this.gridTarget.innerHTML = "";

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", matched.length > 0);
    }

    if (matched.length === 0) {
      if (this.hasMoreTarget) this.moreTarget.classList.add("hidden");
      if (this.hasCountTarget) this.countTarget.textContent = "共 0 篇文章";
      return;
    }

    const featuredSrc = matched[0].querySelector("[data-role='featured']");
    if (featuredSrc)
      this.featuredTarget.appendChild(featuredSrc.content.cloneNode(true));

    const maxRest = this.pageValue * this.pageSizeValue;
    matched.slice(1, 1 + maxRest).forEach((el) => {
      const gridSrc = el.querySelector("[data-role='grid']");
      if (gridSrc) this.gridTarget.appendChild(gridSrc.content.cloneNode(true));
    });

    const hasMore = matched.length > 1 + maxRest;
    if (this.hasMoreTarget)
      this.moreTarget.classList.toggle("hidden", !hasMore);

    if (this.hasCountTarget) {
      const suffix =
        this.filterValue !== "全部" ? ` · ${this.filterValue}` : "";
      this.countTarget.textContent = `共 ${matched.length} 篇文章${suffix}`;
    }
  }
}
